module.exports = __webpack_public_path__ + "static/img/2-2-functions-installation-and-conditionals2x.91ed9fb6.jpg";